export default __webpack_public_path__ + "static/media/nutrionist@2x.b51aad81.png";